import styled from "styled-components"
import theme from "styles/theme-main"
import Highlighter from "react-highlight-words"
import Text from "components/Text"
import { media } from "utils/utils"

export const ControlWrapper = styled.div`
  display: flex;
  width: ${props =>
    props.width ? `${props.width}` : props.medium ? "216px" : "448px"};
  max-width: 100%;
  position: relative;
  background: transparent;

  ${media.md`
    max-width: calc(100vw - 55px);
    width: calc(100vw - 55px);
  `};
`
export const Label = styled(Text)`
  display: block;
  margin-bottom: 14px;
`

export const Hint = styled(Text)`
  margin-bottom: 9px;
`

export const HighlighterWrapper = styled(Highlighter)`
  font-weight: normal;
  font-size: 16px;
  line-height: 30px;
  letter-spacing: 0.2px;

  mark {
    font-weight: bold;
    background: transparent;
  }
`

export const ErrorMessage = styled.div`
  position: absolute;
  display: inline-flex;
  justify-content: flex-end;
  align-items: center;
  margin-left: 9px;
  margin-top: 18px;
  right: 0;
  width: 200px;
`

export const FormIcon = styled.div`
  width: 20px;
  height: 20px;
  margin-left: 9px;
  color: ${props =>
    props.variant === "success"
      ? props.theme.colors.success
      : props.theme.colors.danger};
`

// unfortunately the React select API doesn't provide any way of simply making the value bold through style overrides...
export const SingleValueContainer = styled.span`
  font-weight: bold;

  span {
    font-weight: bold !important;
  }
`

export const customStylesStandard = {
  container: (provided, state) => ({
    ...provided,
    width: provided.medium ? "216px" : "456px",
    maxWidth: "100%",
    backgroundColor: "transparent",
  }),
  placeholder: (provided, state) => ({
    ...provided,
    fontSize: "16px",
    marginLeft: state.selectProps.placeholderMarginLeft
      ? state.selectProps.placeholderMarginLeft
      : "8px",
    fontWeight: "normal",
    color: theme.colors.textSecondary,
    top: "68%",
    //bottom: 0
  }),
  control: (provided, state) => ({
    ...provided,
    fontWeight: "bold",
    boxShadow: "none",
    backgroundColor: "transparent",
    borderRadius: 0,
    borderTopWidth: 0,
    borderLeftWidth: 0,
    borderRightWidth: 0,
    borderBottomWidth: "1px",
    borderColor:
      state.isFocused || state.isSelected
        ? theme.colors.primary
        : theme.colors.border,
    "&:hover": {
      borderColor: theme.colors.primary,
    },
  }),

  input: (provided, state) => ({
    ...provided,
    fontSize: "16px",
    marginLeft: "8px",
    top: "auto",
    bottom: 0,
    color: theme.colors.textPrimary,
  }),
  singleValue: (provided, state) => ({
    ...provided,
    lineHeight: 1.2,
    fontSize: "16px",
    marginLeft: "8px",
    top: "68%",
    color: theme.colors.textPrimary,
  }),
  dropdownIndicator: (provided, state) => ({
    ...provided,
    display: "none",
  }),

  valueContainer: (provided, state) => ({
    ...provided,
    padding: "9px 8px",
    minHeight: "47px",
    backgroundColor: "transparent",
    // eslint-disable-next-line no-useless-computed-key
    ["@media (max-width:1000px)"]: {
      padding: "9px 1px",
    },
  }),
  indicatorSeparator: (provided, state) => ({
    ...provided,
    width: 0,
  }),
  multiValue: (provided, state) => ({
    ...provided,
    borderRadius: "20px",
    padding: "2px 10px",
    "div span": {
      fontWeight: "bold",
      color: theme.colors.textPrimary,
    },
  }),
  multiValueRemove: (provided, state) => ({
    ...provided,
    "&:hover": {
      backgroundColor: "transparent",
      color: theme.colors.textPrimary,
      cursor: "pointer",
    },
    svg: {
      color: "#808b95",
      width: "22px",
      height: "22px",
    },
  }),
}

export const customStylesSide = {
  container: (provided, state) => ({
    ...provided,
    width: provided.medium ? "216px" : "456px",
    maxWidth: "100%",
    backgroundColor: "transparent",
  }),
  placeholder: (provided, state) => ({
    ...provided,
    position: "relative",
    left: "0px",
    width: "320px",
    top: "14px",
    fontSize: "16px",
    marginLeft: "0px",
    fontWeight: "normal",
    color: theme.colors.textSecondary,
    //bottom: 0
  }),
  control: (provided, state) => ({
    ...provided,
    position: "relative",
    fontWeight: "bold",
    boxShadow: "none",
    backgroundColor: "transparent",
    borderRadius: 0,
    borderTopWidth: 0,
    borderLeftWidth: 0,
    borderRightWidth: 0,
    borderBottomWidth: "1px",
    borderColor:
      state.isFocused || state.isSelected
        ? theme.colors.primary
        : theme.colors.border,
    "&:hover": {
      borderColor: theme.colors.primary,
    },
  }),

  input: (provided, state) => ({
    ...provided,
    //border: "1px solid green",
    position: "absolute",
    height: "40px",
    width: "405px",
    top: "7px",
    left: "0px",
    fontSize: "16px",
    lineHeight: "32px",
    marginLeft: "8px",
    bottom: 0,
    color: theme.colors.textPrimary,
  }),
  singleValue: (provided, state) => ({
    ...provided,
    lineHeight: 1.2,
    fontSize: "16px",
    marginLeft: "8px",
    top: "68%",
    color: theme.colors.textPrimary,
  }),
  dropdownIndicator: (provided, state) => ({
    ...provided,
    display: "none",
  }),

  valueContainer: (provided, state) => ({
    ...provided,
    position: "relative",
    overflow: "visible",
    left: 0,
    padding: "9px 8px",
    minHeight: "47px",
    backgroundColor: "transparent",
    // eslint-disable-next-line no-useless-computed-key
    ["@media (max-width:1000px)"]: {
      padding: "9px 1px",
    },
  }),
  indicatorSeparator: (provided, state) => ({
    ...provided,
    width: 0,
  }),
  multiValue: (provided, state) => ({
    ...provided,
    borderRadius: "20px",
    padding: "2px 10px",
    "div span": {
      fontWeight: "bold",
      color: theme.colors.textPrimary,
    },
  }),
  multiValueRemove: (provided, state) => ({
    ...provided,
    "&:hover": {
      backgroundColor: "transparent",
      color: "red",
      cursor: "pointer",
    },
    svg: {
      color: "#808b95",
      width: "22px",
      height: "22px",
    },
  }),
}

export const errorStyles = {
  control: (provided, state) => ({
    ...provided,
    fontWeight: "bold",
    boxShadow: "none",
    borderRadius: 0,
    borderTopWidth: 0,
    borderLeftWidth: 0,
    borderRightWidth: 0,
    backgroundColor: "transparent",
    borderColor: theme.colors.danger,
    "&:hover": {
      borderColor: theme.colors.danger,
    },
  }),
}
